// src/frontend/Adviser/HelperFunctions/generateStyledEmailTemplate.js

/**
 * Wrap raw HTML content in a simple branded email shell.
 * Keep it lightweight and client-safe (no external fonts/CSS).
 *
 * @param {string} content - inner HTML of the email body (already sanitized/constructed)
 * @param {object} [opts]
 * @param {string} [opts.brandColor="#081e56"] - header/accent colour
 * @param {string} [opts.bg="#f7f9fc"] - page background colour
 * @param {number} [opts.maxWidth=760] - max width of email container
 * @param {boolean} [opts.includeHeader=true] - include title header bar
 * @param {string} [opts.title="Rosemount Financial Solutions"] - header title
 */
export const generateStyledEmailTemplate = (
  content,
  {
    brandColor = "#081e56",
    bg = "#f7f9fc",
    maxWidth = 760,
    includeHeader = true,
    title = "Rosemount Financial Solutions",
  } = {}
) => {
  const now = new Date();
  const hr = now.getHours();
  const greeting =
    hr < 12 ? "Good morning all," : hr < 18 ? "Good afternoon all," : "Good evening all,";

  return `
  <!DOCTYPE html>
  <html>
  <head>
    <title>${title}</title>
  </head>
  <body>
        ${content}
    </div>
  </body>
  </html>
  `;
};
